import { render, staticRenderFns } from "./bolt_export.vue?vue&type=template&id=20f52b26&scoped=true&"
import script from "./bolt_export.vue?vue&type=script&lang=js&"
export * from "./bolt_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f52b26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f52b26')) {
      api.createRecord('20f52b26', component.options)
    } else {
      api.reload('20f52b26', component.options)
    }
    module.hot.accept("./bolt_export.vue?vue&type=template&id=20f52b26&scoped=true&", function () {
      api.rerender('20f52b26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/bolt/bolt_export.vue"
export default component.exports